import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//actions
import { postUpdated, updateFilterSelected, clearFilters } from '../actions';

class ClearFilters extends Component {
  /*constructor(props) {
    super(props);
  }*/

  handleonMouseDown = e => {
    //update filters in redux
    this.props.clearFilters('clear_filter', 'clear_filter');
    this.props.postUpdated('asc', 'none', this.props.data, 'clear_filter');
  };

  handleonMouseUp = e => {
    //update filters in redux
    this.props.clearFilters('clear_filter', 'clear_filter');
    this.props.postUpdated('asc', 'none', this.props.data, 'clear_filter');
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.type === 'UPDATE_PEOPLE_DATA') {
      //this.clearField();
    }
  }

  clearField() {
    this.refs.name.value = '';
  }

  render() {
    return (
      <div onMouseDown={this.handleonMouseDown}  onMouseUp={this.handleonMouseUp} className="clearFilters">
        Clear Filters
      </div>
    );
  }
}

ClearFilters.propTypes = {
  data: PropTypes.array
};

const mapDispatchToProps = dispatch => {
  return {
    postUpdated: (sortBy, value, filteredData, filterSelected) =>
      dispatch(postUpdated(sortBy, value, filteredData, filterSelected)),
    updateFilterSelected: (filtername, value) => dispatch(updateFilterSelected(filtername, value)),
    clearFilters: (filtername, value) => dispatch(clearFilters(filtername, value))
  };
};

const mapStateToProps = state => {
  return {
    type: state.postData.type,
    filters: state.filters,
    data: state.postData.data
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClearFilters);
